import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getCostHeads = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/CostHead/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching cost heads:", error);
    throw error;
  }
};

export const saveCostHead = async (costHeadData) => {
  const response = await axios.post(`${BASE_URL}/api/CostHead/save`, costHeadData, {
    headers: getAuthHeader(),
  });
  return response.data;
};



